import { render, staticRenderFns } from "./zTelefone.vue?vue&type=template&id=229296ed&scoped=true&"
import script from "./zTelefone.vue?vue&type=script&setup=true&lang=js&"
export * from "./zTelefone.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229296ed",
  null
  
)

export default component.exports